import constants from 'core/types'

export function updateTradeRoute(routeUpdated) {
  return {
    type: constants.UPDATE_TRADE_ROUTE,
    routeUpdated
  }
}

export function selectCurrency(selectedCurrencies) {
  return {
    type: constants.SELECT_CURRENCY,
    selectedCurrencies
  }
}

export function enterInputAmount(token, inputAmount) {
  return {
    type: constants.ENTER_INPUT_AMOUNT,
    token,
    inputAmount
  }
}



